<div class="bg-midnightnavy d-flex w-p-100 h-100vh ">
  <div class="w-p-100 overflow-scroll ">
    <div class="px-72 py-42 d-flex flex-column justify-content-between h-p-100">
      <!-- <p> -->
      <img src="../../../../assets/images/auth_images/safeignite_logo.svg" width="140" height="44">
      <!-- </p> -->
      <div class="my-2">
        <router-outlet></router-outlet>
      </div>


      <mat-menu #languageMenu="matMenu" class="language-menu">

        <button mat-menu-item (click)="changeLanguage('en')">
            <span class="lang-name">English (India)</span>
        </button>
        <div class="custom-border-1 border-color-darkgrey"></div>
        <button mat-menu-item (click)="changeLanguage('hi')">
            <span class="lang-name">हिन्दी</span>

        </button>


      </mat-menu>
<mat-menu #needHelpMenu="matMenu"  class="need-help-menu">
  <div (click)="$event.stopPropagation()">
    <app-need-help ></app-need-help>
  </div>
</mat-menu>

<div
  class="color-white position-relative d-flex align-items-center justify-content-center cursor-pointer need-help"
  [matMenuTriggerFor]="needHelpMenu"
>
  <p
    [matMenuTriggerFor]="languageMenu"
    class="color-white position-absolute d-flex align-items-center justify-content-center cursor-pointer change-language"
    (click)="$event.stopPropagation()"
  >
    <mat-icon
      class="material-symbols-outlined position-relative fs-24"
      fontIcon="translate_indic">
    </mat-icon>
  </p>

  <mat-icon
    class="material-symbols-outlined fs-24"
    fontIcon="help">
  </mat-icon>

  <span class="ff-Inter ms-2 fs-18 fw-400 line-height-22">
    {{ 'COMMON.NEED_HELP' | translate }}
  </span>
</div>
    </div>
  </div>

  <div class="w-p-100">
    <img src="../../../../assets/images/auth_images/auth_image.jpg" alt="auth-image"
      class="auth-image w-p-100 h-p-100 " />
  </div>
</div>
